
export default {
  name: 'LegalDialog',
  props: {
    value: { type: Boolean, default: false },
    text: { type: String, default: 'tos' },
  },
}
